import React from "react";
import { InlineWidget } from "react-calendly";

export default function CalendlyModal() {
return (
    <div className="calenddly-modal">
     <div className="calenddly-modal_content bg-white" >
        <InlineWidget url="https://calendly.com/itresources-info/30min" />
     </div>
    </div>
);
}